

import React from 'react';
import axios from 'axios'
import AppVars from '../../../../AppVars.js';
import Logger from '../../../../Logger.js';

import UpdatePasswordForm from '../../../Reset/UpdatePasswordForm'
import EmailSent from '../../../Reset/EmailSent'
import ServiceFailure from '../../../Reset/ServiceFailure'
import ResendPasswordForm from '../../../Reset/ResendPasswordForm'
import ResetSuccess from '../../../Reset/ResetSuccess.js';
import AccountInactive from '../../../Reset/AccountInactive'

import Loader from '../../../../static/images/loading.gif'
import {constants} from '../../../../constants/constants'

const appVars = AppVars.getInstance()
const logger = Logger.getInstance();


class ResetParentView extends React.Component {
    constructor(props){
        super(props);
        this.state = {

        };

    }


    
    render(){
        return(
            <div>
            <div className={`${this.props.passwordLoading === true ? "activate-background" : "none" }`} >
                <div className="spinner">
                    <img className='spinner-img' src={Loader} alt="Loading" />
                </div>
            </div>
            {this.props.showForm === "PASSWORD" ? <UpdatePasswordForm style = {this.props.style} code={this.props.code} displayForm = {this.props.displayForm} /> : null}
            {(this.props.showForm === "USED" || this.props.showForm === "EXPIRED" || this.props.showForm === "INVALID" || this.props.showForm === "ERROR") ? <ResendPasswordForm style = {this.props.style} displayForm={this.props.displayForm} showForm={this.props.showForm} loginURI={this.props.loginURI} setEmail={this.props.setEmail}/> : null}
            {this.props.showForm === "SUCCESS" ? <ResetSuccess style = {this.props.style} loginURI = {this.props.loginURI}/> : null}
            {this.props.showForm === "SENT" ? <EmailSent style = {this.props.style} showForm = {this.props.showForm} displayForm = {this.props.displayForm} email={this.props.email} loginURI={this.props.loginURI} /> : null}
            {this.props.showForm === "INACTIVE" ? <AccountInactive style = {this.props.style} email={this.props.email} /> : null}
            {this.props.showForm === "FAILURE" ? <ServiceFailure style = {this.props.style} email={this.props.email} /> : null}
            </div>
          
    );

    }

}

export default ResetParentView;